import { SvgIcon, SvgIconProps } from '@mui/material';
import { RoutalPalette } from '@nx-smartmonkey/ui';

export const PlaceIcon = ({
  color = RoutalPalette.grey1,
  ...props
}: { color?: string } & Omit<SvgIconProps, `color`>) => {
  return (
    <SvgIcon {...props} viewBox="0 0 19.84 19.84" style={{ width: `16px`, height: `16px`, color, ...props.style }}>
      <g>
        <path d="M9.99,1.51c-3.75,0-6.81,2.86-6.81,6.37.05,4.72,5.01,8.83,6.82,10.18,1.79-1.32,6.62-5.33,6.67-10.18,0-1.7-.68-3.3-1.91-4.49-1.25-1.21-2.94-1.88-4.76-1.88M9.99.31c4.43,0,7.88,3.4,7.88,7.59-.06,6.66-7.88,11.65-7.88,11.65,0,0-7.95-5.16-8.02-11.65C1.97,3.7,5.56.31,9.99.31Z" />
        <circle cx="9.92" cy="8.1" r="2.32" />
      </g>
    </SvgIcon>
  );
};
